import BulkActionsController from "controllers/components/bulk_actions_controller"
import { useTimeRangeFilter } from "useTimeRangeFilter"
import {getSelectedIds} from "../../../../helpers/bulkActionHelpers"

export default class extends BulkActionsController {
  static targets = ["form", "bulkReportLink"]

  get signalsController() {
    return document.querySelector("[data-controller~='admin--signals--signals']")["admin--signals--signals"]
  }

  connect() {
    $(this.formTarget).find(".dropdown-menu").on("click", ev => {
      ev.stopPropagation() // keep dropdown menu open
    })

    useTimeRangeFilter(this)
    this.setupSingleToggleCallbacks()
  }

  handleToggleAll(event) {
    super.handleToggleAll(event)
    this.updateBulkReportLink()
  }

  handleToggleSingle(event) {
    this.updateBulkReportLink()
    super.handleToggleSingle(event)
  }

  setupSingleToggleCallbacks() {
    const element = this.hasContainerTarget ? this.containerTarget : this.element
    $(element).on("click", ".bulk-select", this.updateBulkReportLink.bind(this))

    super.setupSingleToggleCallbacks()
  }

  updateBulkReportLink() {
    if (!this.hasBulkReportLinkTarget) {
      return
    }

    const target = this.bulkReportLinkTarget
    const url = new URL(target.dataset.url, window.location.origin)
    const ids = getSelectedIds(target.dataset.scope).split(", ")
    ids.forEach(id => url.searchParams.append("ids[]", id))

    target.href = url.toString()
  }

  async generateIndividual() {
    const target = event.currentTarget
    const reloadOnClose = target.dataset.reloadOnClose

    const resourceId = target.dataset.resourceId
    const resource = { type: "DefenderAlert", id: resourceId }

    await this.signalsController.generate(resource, reloadOnClose, true)
  }

  async generateBulk(ev) {
    await this.signalsController.generateBulk(ev)
  }
}
